export default __webpack_public_path__ + "static/media/whitebg.1178861b.webp";